import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FINAL_CAUSALITY } from '../../../../../routes/paths';
import { asyncGetParam } from '../../../../../services/param.service';
import { IParams } from '../../../../../shared/types/redirectParams';

export const useFinalCausalityDetail = () => {
    const navigate = useNavigate();
    const { idFinalCausality } = useParams();
    const [loading, setLoading] = useState(false);
    const [finalCausality, setFinalCausality] = useState<IParams>();

    useEffect(() => {
        if (Boolean(idFinalCausality?.trim())) {
            setLoading(true);
            asyncGetParam(idFinalCausality?.trim())
                .then((finalCausality: any) => {
                    if (!finalCausality && !finalCausality?.items)
                        navigate(FINAL_CAUSALITY);
                    setFinalCausality(finalCausality?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFinalCausality]);

    return { loading, finalCausality };
};
